import { gql } from "@apollo/client";

export const PERSONS_QUERY = gql`
  query persons($search: String) {
    persons(search: $search) {
      id
      partnerName
    }
  }
`;

export const EMPLOYEES_QUERY = gql`
  query employees($partnerId: Int!) {
    employees(partnerId: $partnerId) {
      employeeId
      employeeName
      hireDate
      badge
      reportsToId
      reportsToName
      address
      employeeStateId
      employeeStateName
      departmentId
      departmentName
      person {
        partnerId
        lastName
        firstName
        genderId
        genderCode
        birthDate
        maritalStatus
        idSeriesAndNumber
        idIssuedBy
        citizenshipId
        citizenshipName
        email
        positionId
        positionName
      }
    }
  }
`;

export const DEPARTMENTS_QUERY = gql`
  query departments {
    departments {
      departmentId
      departmentName
    }
  }
`;

export const PARTNER_STATES_QUERY = gql`
  query partnerStates {
    partnerStates {
      id
      name
    }
  }
`;

export const PERSON_QUERY = gql`
  query person($partnerId: Int) {
    person(partnerId: $partnerId) {
      partnerId
      lastName
      firstName
      genderId
      genderCode
      birthDate
      maritalStatus
      idSeriesAndNumber
      idIssuedBy
      citizenshipId
      citizenshipName
      email
      positionId
      positionName
    }
  }
`;
